export default "__VITE_ASSET__BzkrDong__"